<template>
    <div class="main-loader">
        <img src="@/assets/images/oval.svg" alt="" />
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.main-loader {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 999999;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
